var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1304 9.13086H0.869551C0.389307 9.13086 0 9.52017 0 10.0004C0 10.4807 0.389307 10.87 0.869551 10.87H19.1304C19.6107 10.87 20 10.4807 20 10.0004C20 9.52017 19.6107 9.13086 19.1304 9.13086Z",
    fill: "#4E307A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.869551 4.78207H19.1304C19.6107 4.78207 20 4.39276 20 3.91252C20 3.43228 19.6107 3.04297 19.1304 3.04297H0.869551C0.389307 3.04297 0 3.43228 0 3.91252C0 4.39276 0.389307 4.78207 0.869551 4.78207Z",
    fill: "#4E307A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1304 15.2168H0.869551C0.389307 15.2168 0 15.6061 0 16.0864C0 16.5666 0.389307 16.956 0.869551 16.956H19.1304C19.6107 16.956 20 16.5666 20 16.0864C20 15.6061 19.6107 15.2168 19.1304 15.2168Z",
    fill: "#4E307A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.7443f522e88d48cfab85b7915d445f4d.svg";
export { ForwardRef as ReactComponent };